import { Button } from '@material-ui/core'
import axios from 'axios'
import Dropzone from 'react-dropzone'
import { useDispatch, useSelector } from 'react-redux'
import { sendDeliverablesAddedNotification } from '../../actions/emailActions'

const MultiFilesButton = ({
  setFiles,
  filesUploading,
  setFilesUploading,
  setError,
}) => {
  const dispatch = useDispatch()

  const { userInfo } = useSelector((state) => state.userLogin)
  const { project } = useSelector((state) => state.projectDetails)

  const handleDrop = async (acceptedFiles) => {
    acceptedFiles.map(async (file) => {
      const formData = new FormData()
      formData.append('file', file)
      let item = { name: file.name, size: file.size }

      setFilesUploading((filesUploading) => [...filesUploading, item])

      try {
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${userInfo.token}`,
          },
        }

        const { data } = await axios.post(
          `/api/file/${project._id}`,
          formData,
          config
        )

        setFilesUploading(
          filesUploading.filter((item) => item.name !== file.name)
        )

        setFiles((files) => [...files, data])
      } catch (error) {
        setFilesUploading(
          filesUploading.filter((item) => item.name !== file.name)
        )

        console.error(error)
        setError(error)
      }
    })

    dispatch(sendDeliverablesAddedNotification(project, acceptedFiles.length))
  }

  return (
    <Dropzone onDrop={handleDrop}>
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          <Button
            variant="outlined"
            color="secondary"
            className="btn-white m-r-16"
          >
            <input {...getInputProps()} />
            Add file
          </Button>
        </div>
      )}
    </Dropzone>
  )
}

export default MultiFilesButton
